// test594
(594 && 0);
